var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnackbarClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29715 16.7028C6.90095 16.3066 6.90095 15.6643 7.29715 15.2681L15.2681 7.29715C15.6643 6.90095 16.3066 6.90095 16.7028 7.29715C17.099 7.69335 17.099 8.33572 16.7028 8.73192L8.73192 16.7028C8.33572 17.099 7.69335 17.099 7.29715 16.7028Z",
    fill: "#575B63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29715 7.29715C7.69335 6.90095 8.33572 6.90095 8.73192 7.29715L16.7028 15.2681C17.099 15.6643 17.099 16.3066 16.7028 16.7028C16.3066 17.099 15.6643 17.099 15.2681 16.7028L7.29715 8.73192C6.90095 8.33572 6.90095 7.69335 7.29715 7.29715Z",
    fill: "#575B63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnackbarClose);
export default __webpack_public_path__ + "static/media/snackbar-close.ef000ae1723f80788d271536b00deaf2.svg";
export { ForwardRef as ReactComponent };